(()=>{
  document.documentElement.classList.add('klx-js');
  const qs=(s,c=document)=>c.querySelector(s);
  const qsa=(s,c=document)=>[...c.querySelectorAll(s)];

  const header=qs('[data-klx-header]');
  const mobileToggle=qs('[data-klx-mobile-toggle]');
  if(header&&mobileToggle){
    mobileToggle.addEventListener('click',()=>{
      const open=header.classList.toggle('is-menu-open');
      mobileToggle.setAttribute('aria-expanded',String(open));
    });
    document.addEventListener('keydown',e=>{
      if(e.key==='Escape'){
        header.classList.remove('is-menu-open');
        mobileToggle.setAttribute('aria-expanded','false');
      }
    });
  }

  qsa('[data-klx-nav-item]').forEach(item=>{
    const trigger=qs('[data-klx-nav-trigger]',item);
    if(!trigger)return;
    trigger.addEventListener('click',e=>{
      if(window.innerWidth<=840||trigger.dataset.clickMenu==='true'){
        e.preventDefault();
        const next=!item.classList.contains('is-open');
        qsa('[data-klx-nav-item]').forEach(x=>x.classList.remove('is-open'));
        if(next)item.classList.add('is-open');
        trigger.setAttribute('aria-expanded',String(next));
      }
    });
    qsa('[data-klx-preview]',item).forEach(link=>{
      link.addEventListener('mouseenter',()=>{
        const target=qs('[data-klx-mega-image]',item);
        if(target&&link.dataset.klxPreview){
          target.style.opacity='.2';
          setTimeout(()=>{target.src=link.dataset.klxPreview;target.style.opacity='1'},120);
        }
      });
    });
  });
  document.addEventListener('click',e=>{
    if(!e.target.closest('[data-klx-nav-item]'))qsa('[data-klx-nav-item]').forEach(x=>x.classList.remove('is-open'));
  });

  const reveals=qsa('.klx-reveal');
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target);}
      });
    },{threshold:.12,rootMargin:'0px 0px -40px'});
    reveals.forEach(el=>io.observe(el));
  }else reveals.forEach(el=>el.classList.add('is-in'));

  qsa('[data-klx-faq-button]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const item=btn.closest('.klx-faq__item');
      const next=!item.classList.contains('is-open');
      item.classList.toggle('is-open',next);
      btn.setAttribute('aria-expanded',String(next));
    });
  });

  const quickModal=qs('[data-klx-quick-modal]');
  const quickBody=quickModal?qs('[data-klx-quick-body]',quickModal):null;
  const money=v=>{try{return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(Number(v)/100)}catch(e){return '₹'+(Number(v)/100).toFixed(0)}};
  qsa('[data-klx-quick]').forEach(btn=>btn.addEventListener('click',async()=>{
    if(!quickModal||!quickBody)return;
    quickBody.innerHTML='<p style="text-align:center;padding:28px">Loading product…</p>';
    quickModal.classList.add('is-open');
    quickModal.setAttribute('aria-hidden','false');
    try{
      const r=await fetch(`/products/${btn.dataset.klxQuick}.js`);
      if(!r.ok)throw new Error('Product unavailable');
      const p=await r.json();
      const img=p.featured_image||p.images?.[0]||'';
      quickBody.innerHTML=`<div style="display:grid;grid-template-columns:minmax(180px,.85fr) 1.15fr;gap:24px;align-items:center"><div style="background:#f4f0ec;border-radius:14px;overflow:hidden;aspect-ratio:1/1"><img src="${img}" alt="" style="width:100%;height:100%;object-fit:cover"></div><div><div style="font-size:11px;color:#dd7600;font-weight:800;letter-spacing:.12em">QUICK VIEW</div><h3 style="font-size:24px;margin:8px 0">${p.title}</h3><div style="font-size:20px;font-weight:800;color:#a84316;margin-bottom:16px">${money(p.price)}</div><a href="${p.url}" class="klx-btn klx-btn--primary">View product →</a></div></div>`;
    }catch(err){
      quickBody.innerHTML='<p style="text-align:center;padding:28px">We could not load this product right now. Please open the product page to continue.</p>';
    }
  }));
  if(quickModal){
    qsa('[data-klx-quick-close]',quickModal).forEach(x=>x.addEventListener('click',()=>{quickModal.classList.remove('is-open');quickModal.setAttribute('aria-hidden','true')}));
    quickModal.addEventListener('click',e=>{if(e.target===quickModal){quickModal.classList.remove('is-open');quickModal.setAttribute('aria-hidden','true')}});
  }

  /* Engagement popup is intentionally managed only by klaxon-old-fixes.js so it cannot be suppressed by stale localStorage. */
})();

/* KLAXON hero slider enhancement — scoped to the existing homepage hero only. */
(()=>{
  const hero=document.querySelector('.klx-hero');
  if(!hero||hero.dataset.klxHeroSlider==='ready')return;
  const original=hero.querySelector(':scope > .klx-hero__image');
  if(!original)return;

  const reorderedSlides=[
    {src:'https://cdn.shopify.com/s/files/1/1009/3127/3015/files/klaxon-hero-living-slide-2.png?v=1789557647',alt:'Warm modern living room with KLAXON-style furniture',width:1884,height:835},
    {src:'https://cdn.shopify.com/s/files/1/1009/3127/3015/files/klaxon-hero-dining-slide-3.png?v=1789557665',alt:'Warm modern dining and living room with KLAXON-style furniture',width:1884,height:835}
  ];

  const styleId='klx-hero-slider-style';
  if(!document.getElementById(styleId)){
    const style=document.createElement('style');
    style.id=styleId;
    style.textContent=`
      .klx-hero.klx-hero--slider .klx-hero__slides{position:absolute;inset:0;z-index:-2;overflow:hidden;background:#2f1a10}
      .klx-hero.klx-hero--slider .klx-hero__slide{position:absolute;inset:0;opacity:0;visibility:hidden;transition:opacity .9s cubic-bezier(.22,.61,.36,1),visibility .9s;pointer-events:none}
      .klx-hero.klx-hero--slider .klx-hero__slide.is-active{opacity:1;visibility:visible}
      .klx-hero.klx-hero--slider .klx-hero__slide .klx-hero__image{position:absolute;inset:-2%;z-index:0;width:104%;height:104%;max-width:none;object-fit:cover;object-position:center;animation:none!important;transform:translate3d(0,var(--klx-hero-parallax,0px),0) scale(1.015);transition:transform .2s linear;will-change:transform}
      .klx-hero__arrow{position:absolute;top:50%;z-index:5;width:42px;height:42px;margin:0;padding:0;border:1px solid rgba(255,255,255,.48);border-radius:50%;display:grid;place-items:center;background:rgba(37,20,11,.38);color:#fff;box-shadow:0 6px 20px rgba(0,0,0,.16);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);cursor:pointer;transform:translateY(-50%);transition:background .25s ease,border-color .25s ease,transform .25s ease}
      .klx-hero__arrow:hover,.klx-hero__arrow:focus-visible{background:#ed7c00;border-color:#ed7c00;transform:translateY(-50%) scale(1.06);outline:none}
      .klx-hero__arrow--prev{left:18px}.klx-hero__arrow--next{right:18px}
      .klx-hero__arrow svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
      .klx-hero__dots{position:absolute;left:50%;bottom:18px;z-index:5;display:flex;align-items:center;gap:8px;transform:translateX(-50%);padding:7px 10px;border-radius:999px;background:rgba(37,20,11,.28);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}
      .klx-hero__dot{width:8px;height:8px;margin:0;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.55);cursor:pointer;transition:width .25s ease,background .25s ease,transform .25s ease}
      .klx-hero__dot.is-active{width:23px;border-radius:999px;background:#fff}
      .klx-hero__dot:focus-visible{outline:2px solid #fff;outline-offset:3px}
      @media(max-width:760px){.klx-hero__arrow{width:36px;height:36px}.klx-hero__arrow--prev{left:10px}.klx-hero__arrow--next{right:10px}.klx-hero__dots{bottom:12px}.klx-hero.klx-hero--slider .klx-hero__slide .klx-hero__image{inset:0;width:100%;height:100%;transform:none!important}}
      @media(prefers-reduced-motion:reduce){.klx-hero.klx-hero--slider .klx-hero__slide{transition:none}.klx-hero.klx-hero--slider .klx-hero__slide .klx-hero__image{transform:none!important;transition:none}.klx-hero__arrow,.klx-hero__dot{transition:none}}
    `;
    document.head.appendChild(style);
  }

  const slidesWrap=document.createElement('div');
  slidesWrap.className='klx-hero__slides';
  slidesWrap.setAttribute('aria-hidden','true');
  original.parentNode.insertBefore(slidesWrap,original);

  reorderedSlides.forEach((item,index)=>{
    const slide=document.createElement('div');
    slide.className='klx-hero__slide'+(index===0?' is-active':'');
    const img=document.createElement('img');
    img.className='klx-hero__image';
    img.src=item.src;
    img.alt=item.alt;
    img.width=item.width;
    img.height=item.height;
    img.loading=index===0?'eager':'lazy';
    img.decoding='async';
    if(index===0)img.fetchPriority='high';
    slide.appendChild(img);
    slidesWrap.appendChild(slide);
  });

  const originalSlide=document.createElement('div');
  originalSlide.className='klx-hero__slide';
  original.loading='lazy';
  original.fetchPriority='low';
  originalSlide.appendChild(original);
  slidesWrap.appendChild(originalSlide);

  const slides=[...slidesWrap.children];

  const prev=document.createElement('button');
  prev.type='button';
  prev.className='klx-hero__arrow klx-hero__arrow--prev';
  prev.setAttribute('aria-label','Previous hero image');
  prev.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';

  const next=document.createElement('button');
  next.type='button';
  next.className='klx-hero__arrow klx-hero__arrow--next';
  next.setAttribute('aria-label','Next hero image');
  next.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';

  const dots=document.createElement('div');
  dots.className='klx-hero__dots';
  dots.setAttribute('role','group');
  dots.setAttribute('aria-label','Choose hero image');
  const dotButtons=slides.map((_,i)=>{
    const dot=document.createElement('button');
    dot.type='button';
    dot.className='klx-hero__dot'+(i===0?' is-active':'');
    dot.setAttribute('aria-label','Show hero image '+(i+1));
    if(i===0)dot.setAttribute('aria-current','true');
    dots.appendChild(dot);
    return dot;
  });

  hero.append(prev,next,dots);
  hero.classList.add('klx-hero--slider');
  hero.dataset.klxHeroSlider='ready';

  let active=0;
  let timer=null;
  let paused=false;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');

  const show=index=>{
    active=(index+slides.length)%slides.length;
    slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===active));
    dotButtons.forEach((dot,i)=>{
      const on=i===active;
      dot.classList.toggle('is-active',on);
      if(on)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');
    });
  };

  const stop=()=>{if(timer){window.clearInterval(timer);timer=null;}};
  const start=()=>{
    stop();
    if(reduced.matches||paused||document.hidden)return;
    timer=window.setInterval(()=>show(active+1),6500);
  };

  prev.addEventListener('click',()=>{show(active-1);start();});
  next.addEventListener('click',()=>{show(active+1);start();});
  dotButtons.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start();}));
  hero.addEventListener('mouseenter',()=>{paused=true;stop();});
  hero.addEventListener('mouseleave',()=>{paused=false;start();});
  hero.addEventListener('focusin',()=>{paused=true;stop();});
  hero.addEventListener('focusout',e=>{if(!hero.contains(e.relatedTarget)){paused=false;start();}});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else start();});
  if(reduced.addEventListener)reduced.addEventListener('change',start);

  let touchX=0;
  hero.addEventListener('touchstart',e=>{touchX=e.touches[0]?.clientX||0;},{passive:true});
  hero.addEventListener('touchend',e=>{
    const x=e.changedTouches[0]?.clientX||0;
    const diff=x-touchX;
    if(Math.abs(diff)>45){show(active+(diff<0?1:-1));start();}
  },{passive:true});

  let raf=0;
  const parallax=()=>{
    raf=0;
    if(reduced.matches||window.innerWidth<841){hero.style.removeProperty('--klx-hero-parallax');return;}
    const rect=hero.getBoundingClientRect();
    if(rect.bottom<=0||rect.top>=window.innerHeight)return;
    const offset=Math.max(-14,Math.min(14,(-rect.top)*.035));
    hero.style.setProperty('--klx-hero-parallax',offset.toFixed(1)+'px');
  };
  const requestParallax=()=>{if(!raf)raf=requestAnimationFrame(parallax);};
  window.addEventListener('scroll',requestParallax,{passive:true});
  window.addEventListener('resize',requestParallax,{passive:true});
  parallax();
  show(0);
  start();
})();